export enum ORDER {
	MODIFIED_DATE_DESC = 'modified_date_desc',
	END_DATE_DESC = 'end_date_desc',
	START_DATE_DESC = 'start_date_desc',
	CREATION_DATE_DESC = 'creation_date_desc',
	START_DATE_ASC = 'start_date_asc',
	END_DATE_ASC = 'end_date_asc',
	CREATION_DATE_ASC = 'creation_date_asc',
	MODIFIED_DATE_ASC = 'modified_date_asc',
}
